import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../stores/external-exam-groups-store';
import { CreateExternalExamGroupRequest } from '../../../../../api/types/external-exams/external-exam-group-crud';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const createExternalExamGroupOperation = async (
  request: CreateExternalExamGroupRequest,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!request.groupName || request.groupName.trim().length === 0) {
      toast.warn(`יש להזין את שם המקבץ`);
      return;
    }
    if (!request.year || request.year <= 0) {
      toast.warn(`יש לבחור שנה אקדמית`);
      return;
    }
    if (!request.groupRegistrationDueDate) {
      toast.warn(`יש לבחור תאריך אחרון להרשמה של סטודנטים`);
      return;
    }
    if (request.exams.length === 0) {
      toast.warn(`יש להוסיף לפחות מבחן אחד למקבץ`);
      return;
    }

    setLoading(true);
    const res = await appApi.createExternalExamGroup(request);
    if (res.data.ok && res.data.body) {
      await externalExamGroupsStore.fetchGroups();
      toast.success(`הוספת מקבץ ${request.groupName} התבצעה בהצלחה`);
      onHide();
    } else {
      toast.error(`יצירת מקבץ נכשלה, נסה שוב בעוד מספר רגעים...`);
    }
    setLoading(false);
  } catch (e) {
    toast.error('הוספת מקבץ נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(`createExternalExamGroupOperation failed: ${e}`);
    setLoading(false);
  }
};
